<template>
  <page-view
    :menu="menu"
    :is-loading="loadings.drmInfo || loadings.watermarkGroups"
    fill-height
  >
    <template #header>
      <base-header :title="$t('message.safety')" />
    </template>

    <template #content>
      <v-row no-gutters>
        <v-col cols="12">
          <v-row align="center" no-gutters>
            <span class="pageTitle mb-6">
              {{ $t('message.pages.drm.watermark') }}
            </span>
          </v-row>
        </v-col>
        <v-col cols="12">
          <v-row no-gutters v-if="!isDrmActive">
            <v-col cols="12">
              <v-row no-gutters>
                <v-col cols="12">
                  <v-card flat max-width="50vw">
                    <span class="body-2">
                      <p v-html="$t('message.pages.drm.enabledDrmText')" />
                      <p>
                        <span>{{
                          $t('message.pages.drm.articleAboutIntro')
                        }}</span>
                        <a :href="drmLink" target="_blank">
                          {{ $t('message.pages.drm.articleAbout') }}
                        </a>
                      </p>
                    </span>
                  </v-card>
                </v-col>
                <v-col cols="12" class="pt-5" v-if="hasEditDrmPerm">
                  <v-row no-gutters>
                    <v-col class="shrink pr-2">
                      <v-btn
                        :disabled="loadings.activateDrm"
                        :loading="loadings.activateDrm"
                        min-width="180px"
                        height="38"
                        color="primary"
                        @click="handleDrmSwitch"
                      >
                        <v-icon>mdi-shield-check</v-icon>
                        <span class="mx-2">
                          {{ $t('message.actions.active') }}
                        </span>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col class="pa-0 pr-5" cols="12">
              <v-row no-gutters class="justify-space-between align-center">
                <v-toolbar
                  v-if="selectedGroup.id && !privateKeysSearch"
                  flat
                  class="toolbarMargin"
                >
                  <v-row no-gutters v-if="selectedGroup.id">
                    <v-col cols="7" class="d-flex align-center justify-center">
                      <v-row no-gutters align="center">
                        <v-btn icon color="primary" @click="clearGroup">
                          <v-icon>mdi-chevron-left</v-icon>
                        </v-btn>
                        <span
                          :title="selectedGroup.name"
                          style="max-width: calc(85%)"
                          class="text-truncate"
                        >
                          {{ selectedGroup.name }}
                        </span>
                        <v-btn
                          class="ml-1 mb-1"
                          icon
                          :color="
                            selectedGroup.active ? 'turquisePanda' : 'grey'
                          "
                          @click="handleGoToAdvanced"
                        >
                          <v-icon size="20">
                            {{
                              selectedGroup.active
                                ? 'mdi-lock'
                                : 'mdi-lock-open-variant'
                            }}
                          </v-icon>
                        </v-btn>
                      </v-row>
                    </v-col>
                    <v-col cols="5">
                      <v-row no-gutters justify="end" v-if="groupTab === 0">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              class="ma-2"
                              color="primary"
                              elevation="0"
                              outlined
                              fab
                              v-bind="attrs"
                              v-on="on"
                              @click="goToGroupKeys(true)"
                            >
                              <v-icon> mdi-key-chain </v-icon>
                            </v-btn>
                          </template>
                          <span>
                            {{ $t('message.pages.drm.options.accessKeys') }}
                          </span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              class="ma-2"
                              color="primary"
                              elevation="0"
                              outlined
                              fab
                              v-bind="attrs"
                              v-on="on"
                              @click="handleDrmSettings"
                            >
                              <v-icon> mdi-cog </v-icon>
                            </v-btn>
                          </template>
                          <span>{{
                            $t('message.pages.drm.options.configs')
                          }}</span>
                        </v-tooltip>
                        <v-tooltip
                          bottom
                          v-if="groupTab === 0 && hasEditDrmPerm"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              class="ma-2"
                              color="primary"
                              elevation="0"
                              outlined
                              fab
                              v-bind="attrs"
                              v-on="on"
                              @click="handleGrowSearchBar"
                            >
                              <v-icon> mdi-plus </v-icon>
                            </v-btn>
                          </template>
                          <span>{{
                            $t('message.pages.drm.options.addItem')
                          }}</span>
                        </v-tooltip>
                        <v-tooltip
                          bottom
                          v-if="selectedItems.length && hasEditDrmPerm"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              class="ma-2"
                              color="error"
                              elevation="0"
                              outlined
                              fab
                              v-bind="attrs"
                              v-on="on"
                              @click="handleRemoveItems"
                            >
                              <v-icon> mdi-delete-outline </v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t('message.remove') }}</span>
                        </v-tooltip>
                      </v-row>
                      <v-row no-gutters justify="end" v-if="groupTab === 1">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              class="ma-2"
                              color="primary"
                              elevation="0"
                              outlined
                              fab
                              v-bind="attrs"
                              v-on="on"
                              @click="handleKeysSearch"
                            >
                              <v-icon> mdi-magnify </v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t('message.search') }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              class="ma-2"
                              color="primary"
                              elevation="0"
                              outlined
                              fab
                              v-bind="attrs"
                              v-on="on"
                              @click="getPrivateTokens"
                            >
                              <v-icon> mdi-reload </v-icon>
                            </v-btn>
                          </template>
                          <span>{{
                            $t('message.pages.drm.options.refreshData')
                          }}</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="hasEditDrmPerm">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              class="ma-2"
                              color="primary"
                              elevation="0"
                              outlined
                              fab
                              v-bind="attrs"
                              v-on="on"
                              @click="handleCreateSecretKey"
                            >
                              <v-icon> mdi-key-plus </v-icon>
                            </v-btn>
                          </template>
                          <span>{{
                            $t('message.pages.drm.options.addKey')
                          }}</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="selectedKeys.length">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              class="ma-2"
                              color="error"
                              elevation="0"
                              outlined
                              fab
                              v-bind="attrs"
                              v-on="on"
                              @click="handleRemoveMultipleKeys"
                            >
                              <v-icon> mdi-delete-outline </v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t('message.remove') }}</span>
                        </v-tooltip>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-toolbar>
                <v-col cols="12" v-if="!selectedGroup.id">
                  <v-row no-gutters align="center" v-if="isDrmActive">
                    <v-col cols="9">
                      <div class="body-2">
                        <p v-html="$t('message.pages.drm.enabledDrmText')" />
                        <p>
                          <span>{{
                            $t('message.pages.drm.articleAboutIntro')
                          }}</span>
                          <a :href="drmLink" target="_blank">
                            {{ $t('message.pages.drm.articleAbout') }}
                          </a>
                        </p>
                      </div>
                    </v-col>
                    <v-col cols="3" v-if="hasEditDrmPerm">
                      <v-row no-gutters align="center" justify="end">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              class="ma-2"
                              color="primary"
                              elevation="0"
                              outlined
                              fab
                              v-bind="attrs"
                              v-on="on"
                              :disabled="!isDrmActive"
                              @click="handleNewDrmCategory"
                            >
                              <v-icon>mdi-lock-plus-outline</v-icon>
                            </v-btn>
                          </template>
                          <span>{{
                            $t('message.pages.drm.options.addGroup')
                          }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              class="ma-2"
                              color="primary"
                              elevation="0"
                              fab
                              v-bind="attrs"
                              v-on="on"
                              @click="handleDrmSwitch"
                            >
                              <v-icon>{{
                                isDrmActive
                                  ? 'mdi-shield-check'
                                  : 'mdi-shield-off'
                              }}</v-icon>
                            </v-btn>
                          </template>
                          <span>DRM {{ $t('message.commom.able') }}</span>
                        </v-tooltip>
                      </v-row>
                    </v-col>
                  </v-row>
                  <template
                    v-if="
                      loadings.watermarkGroups ||
                      isDrmActive ||
                      (isDrmActive && errors.groupsError)
                    "
                  >
                    <template v-if="loadings.watermarkGroups">
                      <v-card
                        class="d-flex flex-row justify-center align-center"
                        width="100%"
                        flat
                      >
                        <loading-logo :value="200" />
                      </v-card>
                    </template>

                    <template
                      v-if="!errors.groupsError && !loadings.watermarkGroups"
                    >
                      <v-card v-if="!isFetching" flat height="40px">
                        <v-row no-gutters>
                          <v-col class="d-flex align-center justify-start pl-4">
                            <v-hover v-slot="{ hover }">
                              <v-row no-gutters @click="switchGroupNameOrder">
                                <span
                                  class="caption mt-1 ml-1"
                                  style="height: 24px"
                                >
                                  <b>{{
                                    $t('message.pages.drm.tableColumns.groups')
                                  }}</b>
                                </span>
                                <v-icon
                                  v-if="hover && !groupNameOrder"
                                  color="grey lighten-1"
                                  >mdi-menu-down</v-icon
                                >
                                <v-icon
                                  v-if="hover && groupNameOrder === 'desc'"
                                  >mdi-menu-down</v-icon
                                >
                                <v-icon v-if="hover && groupNameOrder === 'asc'"
                                  >mdi-menu-up</v-icon
                                >
                              </v-row>
                            </v-hover>
                          </v-col>
                          <v-card
                            class="d-flex align-center"
                            height="45px"
                            flat
                            width="125px"
                          >
                            <span
                              class="caption mt-1 pl-6"
                              style="height: 24px"
                            >
                              <b>Status</b>
                            </span>
                          </v-card>
                          <v-card
                            class="d-flex align-center"
                            height="45px"
                            flat
                            width="112px"
                          >
                            <v-hover v-slot="{ hover }">
                              <v-row
                                no-gutters
                                justify="center"
                                @click="switchFolderAmountOrder"
                              >
                                <span class="caption mt-1" style="height: 24px">
                                  <b>{{
                                    $t('message.pages.drm.tableColumns.folders')
                                  }}</b>
                                </span>
                                <v-icon
                                  v-if="hover && !groupFolderOrder"
                                  color="grey lighten-1"
                                  >mdi-menu-down</v-icon
                                >
                                <v-icon
                                  v-if="hover && groupFolderOrder === 'desc'"
                                  >mdi-menu-down</v-icon
                                >
                                <v-icon
                                  v-if="hover && groupFolderOrder === 'asc'"
                                  >mdi-menu-up</v-icon
                                >
                              </v-row>
                            </v-hover>
                          </v-card>
                          <v-card
                            class="d-flex align-center"
                            height="45px"
                            flat
                            width="118px"
                          >
                            <v-hover v-slot="{ hover }">
                              <v-row
                                no-gutters
                                justify="center"
                                @click="switchVideoAmountOrder"
                              >
                                <span class="caption mt-1" style="height: 24px">
                                  <b>{{
                                    $t('message.pages.drm.tableColumns.videos')
                                  }}</b>
                                </span>
                                <v-icon
                                  v-if="hover && !groupVideosOrder"
                                  color="grey lighten-1"
                                  >mdi-menu-down</v-icon
                                >
                                <v-icon
                                  v-if="hover && groupVideosOrder === 'desc'"
                                  >mdi-menu-down</v-icon
                                >
                                <v-icon
                                  v-if="hover && groupVideosOrder === 'asc'"
                                  >mdi-menu-up</v-icon
                                >
                              </v-row>
                            </v-hover>
                          </v-card>
                          <v-card
                            class="d-flex align-center"
                            height="45px"
                            flat
                            width="110px"
                          >
                            <v-hover v-slot="{ hover }">
                              <v-row
                                no-gutters
                                @click="switchTsOrder"
                                justify="center"
                              >
                                <span class="caption mt-1" style="height: 24px">
                                  <b>Marcação</b>
                                </span>
                                <v-icon
                                  v-if="hover && !groupTsOrder"
                                  color="grey lighten-1"
                                  >mdi-menu-down</v-icon
                                >
                                <v-icon v-if="hover && groupTsOrder === 'desc'"
                                  >mdi-menu-down</v-icon
                                >
                                <v-icon v-if="hover && groupTsOrder === 'asc'"
                                  >mdi-menu-up</v-icon
                                >
                              </v-row>
                            </v-hover>
                          </v-card>
                        </v-row>
                      </v-card>
                      <vue-virtual-table
                        v-if="drmWatermarkGroups.length > 0"
                        class="pointerTable"
                        :class="{
                          virtualTable: $vuetify.theme.dark,
                        }"
                        :style="selectedGroup.id ? 'display: none' : ''"
                        :data="drmWatermarkGroups"
                        :config="headers"
                        :height="tableHeight"
                        :itemHeight="48"
                        :minWidth="770"
                        @contextmenu="showDrmMenu"
                        @click="handleSelectGroup"
                      >
                        <template slot-scope="scope" slot="nameCommon">
                          <v-row
                            no-gutters
                            @click="handleSelectGroup(scope.row)"
                            class="pl-3 pt-2"
                            style="max-width: 100%"
                            align="center"
                          >
                            <span :title="scope.row.name" class="text-truncate">
                              <v-icon
                                :color="
                                  scope.row.active ? 'turquisePanda' : 'grey'
                                "
                                class="pr-1"
                                small
                              >
                                {{
                                  scope.row.active
                                    ? 'mdi-lock'
                                    : 'mdi-lock-open-variant'
                                }}
                              </v-icon>
                              {{ scope.row.name }}
                            </span>
                          </v-row>
                        </template>
                        <template slot-scope="scope" slot="status">
                          <v-chip-legacy
                            v-if="scope.row.active"
                            class="justify-center align-center"
                            label
                            small
                            style="width: 95px"
                            color="primary"
                          >
                            {{ $t('message.commom.able') }}
                          </v-chip-legacy>
                          <v-chip-legacy
                            v-else
                            class="justify-center align-center"
                            label
                            small
                            style="width: 95px"
                          >
                            {{ $t('message.commom.disabled') }}
                          </v-chip-legacy>
                        </template>
                        <template slot-scope="scope" slot="foldersCountCommom">
                          <v-row
                            no-gutters
                            justify="end"
                            @click="handleSelectGroup(scope.row)"
                          >
                            <span class="pr-10">{{
                              getFoldersInsideGroup(scope.row)
                            }}</span>
                          </v-row>
                        </template>
                        <template slot-scope="scope" slot="videosCountCommom">
                          <v-row
                            no-gutters
                            justify="end"
                            @click="handleSelectGroup(scope.row)"
                          >
                            <span class="pr-10">{{
                              getQuantityInsideGroup(scope.row)
                            }}</span>
                          </v-row>
                        </template>
                        <template slot-scope="scope" slot="securityCommom">
                          <v-row
                            no-gutters
                            justify="end"
                            @click="handleSelectGroup(scope.row)"
                          >
                            <span class="pr-9">
                              {{ Math.round(scope.row.percent_ts * 100) }}%
                            </span>
                          </v-row>
                        </template>
                      </vue-virtual-table>
                      <template v-else>
                        <v-container fill-height class="my-5">
                          <v-row
                            class="d-flex flex-column"
                            no-gutters
                            justify="center"
                            align="center"
                          >
                            <img
                              v-if="$vuetify.theme.dark"
                              class="ml-4"
                              src="@/assets/pandaLogo.svg"
                              max-width="180"
                            />
                            <img
                              v-else
                              class="ml-4"
                              src="@/assets/pandaHappy.svg"
                              max-width="180"
                            />
                            <span class="noFilesAddedText">
                              Você ainda não possui nenhum grupo, <br />
                              Crie um clicando na opção "Adicionar" acima.
                            </span>
                          </v-row>
                          <v-col class="d-flex justify-end align-end">
                            <img
                              class="svgArrowUp pb-16 mb-10"
                              src="@/assets/arrowUp.svg"
                            />
                          </v-col>
                        </v-container>
                      </template>
                    </template>
                    <v-row
                      v-if="errors.groupsError"
                      no-gutters
                      align="center"
                      justify="center"
                    >
                      <v-card width="100%" height="400" class="mb-16" flat>
                        <v-row no-gutters justify="center" align="center">
                          <v-col
                            cols="6"
                            class="d-flex justify-start align-start flex-column"
                          >
                            <span class="text-h6"
                              >{{ $t('message.videoApiError') }}
                              {{ errors.groupsUnknownErrorCode }}).</span
                            >
                            <br />
                            <span class="text-subheading">
                              {{ $t('message.videoApiErrMsg') }} <br />
                              <button
                                type="button"
                                class="primary--text"
                                @click="handleStatusPage"
                              >
                                <span class="primary--text">
                                  {{ $t('message.checkStatusPageLink') }}
                                </span>
                              </button>
                            </span>
                            <br />
                          </v-col>
                          <v-col cols="12">
                            <v-row no-gutters align="center" justify="center">
                              <v-btn
                                color="primary"
                                class="ma-2 ml-3 white--text"
                                rounded
                                @click="getDrmGroups"
                              >
                                <span class="mx-2">{{
                                  $t('message.tryAgain')
                                }}</span>
                                <v-icon right dark> mdi-cached </v-icon>
                              </v-btn>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-row>
                  </template>
                </v-col>
                <v-col cols="12" v-else>
                  <v-row no-gutters>
                    <v-col
                      cols="12"
                      v-if="selectedGroup.id && privateKeysSearch"
                      class="mb-6"
                    >
                      <v-row no-gutters class="align-center justify-space">
                        <v-text-field
                          v-model="searchKeysText"
                          :placeholder="$t('message.pages.drm.searchKey')"
                          dense
                          hide-details
                          solo
                          autofocus
                          class="elevation-0"
                          @keydown="checkIfEscWasPressed"
                        ></v-text-field>
                        <v-btn
                          class="ml-4"
                          icon
                          color="grey"
                          @click="handleCloseSearchBar"
                        >
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-row>
                    </v-col>
                    <v-col
                      cols="12"
                      v-if="selectedGroup.id && openSearchBar && groupTab == 0"
                      class="pt-3"
                    >
                      <v-toolbar flat>
                        <v-row
                          class="d-flex align-center justify-space-between"
                        >
                          <v-autocomplete
                            ref="autoCompleteInputDRM"
                            @update:search-input="filterSearch"
                            :placeholder="
                              $t(
                                'message.pages.videosDataTable.searchBar.placeholder'
                              )
                            "
                            :items="filteredVideoList"
                            :loading="loadingSearchBar"
                            clearable
                            dense
                            hide-details
                            hide-selected
                            :label="
                              $t(
                                'message.pages.videosDataTable.searchBar.placeholder'
                              )
                            "
                            autocomplete="off"
                            aria-autocomplete="off"
                            solo
                            no-filter
                            auto-select-first
                            autofocus
                            :append-icon="''"
                            @change="handleSelectRowItem"
                            @blur="handleSearchBlur"
                          >
                            <template v-slot:no-data>
                              <v-list-item>
                                <v-list-item-title>
                                  {{
                                    $t(
                                      'message.pages.videosDataTable.searchBar.noData'
                                    )
                                  }}
                                </v-list-item-title>
                              </v-list-item>
                            </template>
                            <template
                              v-slot:selection="{ attr, on, item, selected }"
                            >
                              <span
                                v-bind="attr"
                                :input-value="selected"
                                v-on="on"
                              >
                                <span>{{
                                  item.name ? item.name : item.title
                                }}</span>
                              </span>
                            </template>
                            <template v-slot:item="{ item }">
                              <v-row
                                no-gutters
                                @click="handleSelectRowItem(item)"
                              >
                                <v-list-item-avatar>
                                  <v-icon
                                    v-if="item.name"
                                    color="turquisePanda"
                                  >
                                    mdi-folder
                                  </v-icon>
                                  <v-icon v-else color="turquisePanda">
                                    mdi-play-circle-outline
                                  </v-icon>
                                </v-list-item-avatar>
                                <v-list-item-content class="py-0">
                                  <v-list-item-title>
                                    <v-row
                                      no-gutters
                                      class="d-flex flex-column"
                                    >
                                      <span>
                                        {{ item.name || item.title }}
                                      </span>
                                    </v-row>
                                  </v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                  <v-row no-gutters>
                                    <v-icon>mdi-chevron-right</v-icon>
                                  </v-row>
                                </v-list-item-action>
                              </v-row>
                            </template>
                          </v-autocomplete>
                          <v-btn
                            class="ml-4"
                            icon
                            color="grey"
                            @click="handleUngrowBar"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                          <v-card
                            v-if="loadingVideosAdd"
                            class="d-flex align-center justify-center"
                            flat
                            height="48"
                            width="64"
                          >
                            <v-progress-circular
                              :size="22"
                              :width="3"
                              color="primary"
                              indeterminate
                            ></v-progress-circular>
                          </v-card>
                        </v-row>
                      </v-toolbar>
                    </v-col>
                    <v-col cols="11" v-if="isDrmItemDuplicated">
                      <v-alert
                        colored-border
                        class="mt-4 ml-2"
                        color="warning"
                        icon="mdi-alert"
                        elevation="2"
                        border="left"
                        type="warning"
                      >
                        {{ $t('message.pages.drm.hasDrmGroup') }}
                      </v-alert>
                    </v-col>
                    <template v-if="groupTab === 0">
                      <v-card
                        v-if="!isFetching"
                        flat
                        width="800px"
                        height="45px"
                      >
                        <v-row no-gutters>
                          <v-card
                            class="d-flex align-center justify-center pl-2"
                            height="45px"
                            flat
                            width="60px"
                          >
                            <v-simple-checkbox
                              :color="
                                !checkboxIndeterminateStatus ? 'primary' : ''
                              "
                              :indeterminate="checkboxIndeterminateStatus"
                              :ripple="false"
                              :value="anyItemSelected"
                              @input="selectAllItems"
                            ></v-simple-checkbox>
                          </v-card>
                          <v-col class="d-flex align-center justify-start pl-4">
                            <v-hover v-slot="{ hover }">
                              <v-row no-gutters @click="switchItemsNameOrder">
                                <span class="caption mt-1" style="height: 24px">
                                  <b>{{
                                    $t(
                                      'message.pages.videosDataTable.header.name'
                                    )
                                  }}</b>
                                </span>
                                <v-icon
                                  v-if="hover && !itemNameOrder"
                                  color="grey lighten-1"
                                  >mdi-menu-down</v-icon
                                >
                                <v-icon v-if="itemNameOrder === 'desc'"
                                  >mdi-menu-down</v-icon
                                >
                                <v-icon v-if="itemNameOrder === 'asc'"
                                  >mdi-menu-up</v-icon
                                >
                              </v-row>
                            </v-hover>
                          </v-col>
                        </v-row>
                      </v-card>
                      <vue-virtual-table
                        v-if="loadedItems.length > 0"
                        :class="{
                          displayNone: isFetchingVideos,
                          displayBlock: !isFetchingVideos,
                          virtualTable: $vuetify.theme.dark,
                        }"
                        :data="loadedItems"
                        :config="tableConfig"
                        :height="tableHeight"
                        :itemHeight="48"
                        :minWidth="770"
                        @contextmenu="show"
                        @click="handleClickRow"
                      >
                        <template slot-scope="scope" slot="selectCommon">
                          <v-row
                            class="pt-1"
                            no-gutters
                            justify="center"
                            align="center"
                          >
                            <v-simple-checkbox
                              color="primary"
                              :ripple="false"
                              :value="checkIfSelected(scope.row)"
                              @input="checkboxSelection(scope.row)"
                            ></v-simple-checkbox>
                          </v-row>
                        </template>
                        <template slot-scope="scope" slot="titleCommon">
                          <v-row
                            no-gutters
                            @click="handleClickRow(scope.row)"
                            justify="center"
                            class="pt-1"
                          >
                            <template v-if="scope.row.name">
                              <v-row
                                no-gutters
                                class="d-flex flex-row align-center"
                              >
                                <v-icon color="turquisePanda">
                                  mdi-folder
                                </v-icon>
                                <span
                                  class="text-truncate pr-1 pl-2"
                                  style="max-width: calc(95% - 50px)"
                                  >{{ scope.row.name }}</span
                                >
                              </v-row>
                            </template>
                            <template v-else>
                              <v-row
                                no-gutters
                                class="d-flex flex-row align-center"
                              >
                                <v-icon color="turquisePanda">
                                  mdi-play-circle-outline
                                </v-icon>
                                <span
                                  :title="scope.row.title"
                                  class="text-truncate pl-2"
                                  style="max-width: calc(95% - 145px)"
                                >
                                  {{ scope.row.title }}
                                </span>
                              </v-row>
                            </template>
                          </v-row>
                        </template>
                        <template slot-scope="scope" slot="hoverCommom">
                          <v-row
                            no-gutters
                            justify="center"
                            v-if="hasEditDrmPerm"
                          >
                            <div class="hoveredClass">
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    class="mr-3"
                                    v-if="scope.row.title"
                                    icon
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="handleRemoveItemFromDrm(scope.row)"
                                  >
                                    <v-icon color="primary">
                                      mdi-delete-outline
                                    </v-icon>
                                  </v-btn>
                                </template>
                                <span>{{ $t('message.remove') }} </span>
                              </v-tooltip>
                            </div>
                          </v-row>
                        </template>
                      </vue-virtual-table>
                      <template v-else>
                        <v-container fill-height class="my-5">
                          <v-row
                            class="d-flex flex-column"
                            no-gutters
                            justify="center"
                            align="center"
                          >
                            <img
                              v-if="$vuetify.theme.dark"
                              class="ml-4"
                              src="@/assets/pandaLogo.svg"
                              max-width="180"
                            />
                            <img
                              v-else
                              class="ml-4"
                              src="@/assets/pandaHappy.svg"
                              max-width="180"
                            />
                            <span class="noFilesAddedText">
                              {{ $t('message.pages.drm.noFilesInGroup1') }}
                              <br />
                              {{ $t('message.pages.drm.noFilesInGroup2') }}
                            </span>
                          </v-row>
                          <v-col class="d-flex justify-end align-end">
                            <img
                              class="svgArrowUp pb-16 mb-10"
                              src="@/assets/arrowUp.svg"
                            />
                          </v-col>
                        </v-container>
                      </template>
                    </template>
                    <template v-if="groupTab === 2">
                      <drm-edit-group :selectedGroup="selectedGroup" />
                    </template>
                    <v-col cols="12" v-if="groupTab === 1">
                      <v-card v-if="!isFetching" flat height="40px">
                        <v-row no-gutters>
                          <v-card
                            class="d-flex align-center justify-center pl-2"
                            height="45px"
                            flat
                            width="60px"
                          >
                            <v-simple-checkbox
                              :color="
                                !checkboxIndeterminateStatusTokens
                                  ? 'primary'
                                  : ''
                              "
                              :indeterminate="checkboxIndeterminateStatusTokens"
                              :ripple="false"
                              :value="anyTokenSelected"
                              @input="selectAllTokens"
                            ></v-simple-checkbox>
                          </v-card>
                          <v-col class="d-flex align-center justify-start pl-4">
                            <v-hover v-slot="{ hover }">
                              <v-row no-gutters @click="switchTokenNameOrder">
                                <span class="caption mt-1" style="height: 24px"
                                  ><b>{{ $t('message.commom.key') }}</b></span
                                >
                                <v-icon
                                  v-if="hover && !tokenNameOrder"
                                  color="grey lighten-1"
                                  >mdi-menu-down</v-icon
                                >
                                <v-icon
                                  v-if="hover && tokenNameOrder === 'desc'"
                                  >mdi-menu-down</v-icon
                                >
                                <v-icon v-if="hover && tokenNameOrder === 'asc'"
                                  >mdi-menu-up</v-icon
                                >
                              </v-row>
                            </v-hover>
                          </v-col>
                          <v-card
                            class="d-flex align-center justify-center"
                            height="45px"
                            flat
                            width="145px"
                          >
                            <span
                              class="caption mt-1 mr-8"
                              style="height: 24px"
                            >
                              <b>Status</b>
                            </span>
                          </v-card>
                          <v-card
                            class="d-flex align-center justify-start pl-1"
                            height="45px"
                            flat
                            width="150px"
                          >
                            <span class="caption"
                              ><b
                                >{{ $t('message.pages.drm.field') }} 1</b
                              ></span
                            >
                          </v-card>
                          <v-card
                            class="d-flex align-center justify-start pl-1"
                            height="45px"
                            flat
                            width="152px"
                          >
                            <span class="caption"
                              ><b
                                >{{ $t('message.pages.drm.field') }} 2</b
                              ></span
                            >
                          </v-card>
                          <v-card
                            class="d-flex align-center justify-start pl-1"
                            height="45px"
                            flat
                            :width="
                              filteredKeys.length > 12 ? '168px' : '152px'
                            "
                          >
                            <span class="caption"
                              ><b
                                >{{ $t('message.pages.drm.field') }} 3</b
                              ></span
                            >
                          </v-card>
                        </v-row>
                      </v-card>
                      <vue-virtual-table
                        class="mt-2 pointerTable"
                        :class="{
                          displayNone: fetchingPrivateKeys,
                          displayBlock: !fetchingPrivateKeys,
                          virtualTable: $vuetify.theme.dark,
                        }"
                        v-if="groupPrivateTokens.length > 0"
                        :style="selectedGroup.id ? 'display: none' : ''"
                        :data="filteredKeys"
                        :config="secretKeysHeader"
                        :height="tableHeight"
                        :itemHeight="48"
                        :minWidth="770"
                        @contextmenu="showTokensMenu"
                        @click="handleRowSecretToken"
                      >
                        <template slot-scope="scope" slot="selectCommon">
                          <v-row
                            class="pt-1"
                            no-gutters
                            justify="center"
                            align="center"
                          >
                            <v-simple-checkbox
                              color="primary"
                              :ripple="false"
                              :value="checkIfSelectedToken(scope.row)"
                              @input="checkboxSelectionToken(scope.row)"
                            ></v-simple-checkbox>
                          </v-row>
                        </template>
                        <template slot-scope="scope" slot="keyCommom">
                          <v-row
                            no-gutters
                            @click="handleRowSecretToken(scope.row)"
                            class="pl-2 pt-1"
                            style="max-width: 100%"
                          >
                            <span :title="scope.row.key" class="text-truncate">
                              <v-icon
                                :color="
                                  scope.row.status_key
                                    ? 'turquisePanda'
                                    : 'grey'
                                "
                                class="pr-1 pb-1"
                              >
                                mdi-key
                              </v-icon>
                              {{ scope.row.key }}
                            </span>
                          </v-row>
                        </template>
                        <template slot-scope="scope" slot="status">
                          <v-row
                            no-gutters
                            @click="handleRowSecretToken(scope.row)"
                          >
                            <v-chip-legacy
                              v-if="scope.row.status_key"
                              class="justify-center align-center"
                              label
                              small
                              style="width: 95px"
                              color="primary"
                            >
                              {{ $t('message.commom.able') }}
                            </v-chip-legacy>
                            <v-chip-legacy
                              v-else
                              class="justify-center align-center"
                              label
                              small
                              style="width: 95px"
                            >
                              {{ $t('message.commom.disabled') }}
                            </v-chip-legacy>
                          </v-row>
                        </template>
                        <template slot-scope="scope" slot="string1Commom">
                          <v-row
                            no-gutters
                            justify="start"
                            class="pt-2"
                            style="max-width: 100%"
                            @click="handleRowSecretToken(scope.row)"
                          >
                            <span
                              :title="scope.row.string1"
                              class="text-truncate"
                            >
                              {{ scope.row.string1 }}
                            </span>
                          </v-row>
                        </template>
                        <template slot-scope="scope" slot="string2Commom">
                          <v-row
                            no-gutters
                            justify="start"
                            class="pt-2"
                            style="max-width: 100%"
                            @click="handleRowSecretToken(scope.row)"
                          >
                            <span
                              :title="scope.row.string2"
                              class="text-truncate"
                            >
                              {{ scope.row.string2 }}
                            </span>
                          </v-row>
                        </template>
                        <template slot-scope="scope" slot="string3Commom">
                          <v-row
                            @click="handleRowSecretToken(scope.row)"
                            no-gutters
                            justify="start"
                            class="pt-2"
                            style="max-width: 100%"
                          >
                            <span
                              :title="scope.row.string3"
                              class="text-truncate"
                            >
                              {{ scope.row.string3 }}
                            </span>
                          </v-row>
                        </template>
                      </vue-virtual-table>
                      <v-container v-if="fetchingPrivateKeys" class="my-5">
                        <v-row no-gutters align="center" justify="center">
                          <loading-logo :value="200" />
                        </v-row>
                      </v-container>
                      <template v-else>
                        <v-container
                          v-if="
                            !fetchingPrivateKeys && !groupPrivateTokens.length
                          "
                          class="my-5"
                        >
                          <v-row
                            class="d-flex flex-column"
                            no-gutters
                            justify="center"
                            align="center"
                          >
                            <img
                              v-if="$vuetify.theme.dark"
                              class="ml-4"
                              src="@/assets/pandaLogo.svg"
                              max-width="180"
                            />
                            <img
                              v-else
                              class="ml-4"
                              src="@/assets/pandaHappy.svg"
                              max-width="180"
                            />
                            <span class="noFilesAddedText">
                              {{ $t('message.pages.drm.noKeys1') }}<br />
                              {{ $t('message.pages.drm.noKeys2') }}
                            </span>
                          </v-row>
                          <v-col class="d-flex justify-end align-end">
                            <img
                              class="svgArrowUp pb-16 mb-10"
                              src="@/assets/arrowUp.svg"
                            />
                          </v-col>
                        </v-container>
                      </template>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- context menu -->
      <v-menu
        v-model="showMenuDrm"
        min-width="300px"
        :position-x="x"
        :position-y="y"
        absolute
        offset-y
        :transition="null"
      >
        <v-list dense>
          <v-list-item @click="handleSelectGroup(menuItemDrm)">
            <v-list-item-icon>
              <v-icon>mdi-eye-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{
              $t('message.pages.videosDataTable.menu.open')
            }}</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="hasEditDrmPerm"
            @click="handleEditGroup(menuItemDrm)"
          >
            <v-list-item-icon>
              <v-icon>mdi-pencil</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ $t('message.edit') }}</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="hasEditDrmPerm"
            @click="handleDeleteGroup(menuItemDrm)"
          >
            <v-list-item-icon>
              <v-icon>mdi-delete</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ $t('message.remove') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu
        v-if="hasEditDrmPerm"
        v-model="showMenu"
        min-width="300px"
        :position-x="x"
        :position-y="y"
        absolute
        offset-y
        :transition="null"
      >
        <v-list dense>
          <v-list-item @click="handleRemoveItemFromDrm(menuItem)">
            <v-list-item-icon>
              <v-icon>mdi-delete</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ $t('message.remove') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <!-- dialogs -->
      <drm-create-group />
      <drm-warning />
      <drm-remove-video />
      <drm-remove-group />
      <drm-create-secret-key />
      <drm-remove-multiple-keys />
      <drm-modal-group-settings :drmGroup="selectedGroup" />
    </template>
  </page-view>
</template>

<script>
// external imports
import { mapMutations, mapState } from 'vuex'
import VueVirtualTable from 'vue-virtual-table'
import Fuse from 'fuse.js'

// internal imports
import i18n from '@/translations/lang'
import {
  PANDA_STATUS_PAGE_BR,
  DRM_LINK_PT_BR,
  DRM_LINK_EN_US,
} from '@/config/envs'

// API
import drmApi from '@/services/drmApi'
import foldersApi from '@/services/foldersApi'
import videosApi from '@/services/videosApi'

// Components
import DrmCreateGroup from './DrmCreateGroup.vue'
import DrmWarning from './DrmWarning.vue'
import DrmRemoveVideo from './DrmRemoveVideo.vue'
import DrmRemoveGroup from './DrmRemoveGroup.vue'
import DrmEditGroup from './DrmEditGroup.vue'
import DrmCreateSecretKey from './DrmCreateSecretKey.vue'
import DrmRemoveMultipleKeys from './DrmRemoveMultipleKeys.vue'
import DrmModalGroupSettings from './DrmSettings/DrmModalGroupSettings.vue'
import LoadingLogo from '@/components/LoadingLogo.vue'
import PageView from '@/layout/PageView.vue'

export default {
  name: 'DRM',
  components: {
    DrmCreateGroup,
    DrmWarning,
    VueVirtualTable,
    DrmRemoveVideo,
    DrmRemoveGroup,
    DrmEditGroup,
    DrmCreateSecretKey,
    DrmRemoveMultipleKeys,
    LoadingLogo,
    DrmModalGroupSettings,
    PageView,
    BaseHeader: () => import('@/components/BaseHeader.vue'),
  },
  data: () => ({
    isDrmActive: false,
    loadings: {
      drmInfo: false,
      activateDrm: false,
      deactivateDrm: false,
      watermarkGroups: false,
    },
    errors: {
      groupsError: false,
      groupsUnknownErrorCode: 503,
    },
    drmWatermarkGroups: [],
    selectedGroup: {},
    headers: [
      {
        prop: '_action',
        name: i18n.t('message.name'),
        actionName: 'nameCommon',
        alignItems: 'start',
      },
      {
        prop: '_action',
        actionName: 'status',
        alignItems: 'center',
        width: 140,
      },
      {
        prop: '_action',
        actionName: 'foldersCountCommom',
        alignItems: 'right',
        width: 110,
      },
      {
        prop: '_action',
        actionName: 'videosCountCommom',
        alignItems: 'right',
        width: 110,
      },
      {
        prop: '_action',
        actionName: 'securityCommom',
        alignItems: 'right',
        width: 110,
      },
    ],
    tableConfig: [
      {
        prop: '_action',
        name: 'action',
        actionName: 'selectCommon',
        width: 60,
        alignItems: 'start',
      },
      {
        prop: '_action',
        name: i18n.t('message.name'),
        actionName: 'titleCommon',
        alignItems: 'start',
      },
      {
        prop: '_action',
        actionName: 'hoverCommom',
        alignItems: 'center',
        width: 130,
      },
    ],
    tableHeight: window.innerHeight - 240,
    isFetchingVideos: false,
    isFetching: false,
    loadedVideos: [],
    loadedFolders: [],
    db: null,
    selectedItems: [],
    loadingSearchBar: false,
    filteredVideoList: [],
    toBeAddedItems: [],
    checkIfClicked: false,
    loadingVideosAdd: false,
    openSearchBar: false,
    tab: 1,
    items: [
      { tab: 'Domínios' },
      {
        tab: 'Marca D&#180água (DRM) <sup class="pl-1 turquisePanda--text font-weight-normal">BETA</sup>',
      },
    ],
    groupTab: 0,
    showMenu: false,
    menuItem: {},
    showMenuDrm: false,
    menuItemDrm: {},
    x: 0,
    y: 0,
    fetchingPrivateKeys: false,
    groupPrivateTokens: [],
    secretKeys: [],
    selectedKeys: [],
    menuItemTokem: [],
    secretKeysHeader: [
      {
        prop: '_action',
        name: 'action',
        actionName: 'selectCommon',
        width: 60,
        alignItems: 'start',
      },
      {
        prop: '_action',
        name: i18n.t('message.name'),
        actionName: 'keyCommom',
        alignItems: 'start',
      },
      {
        prop: '_action',
        actionName: 'status',
        alignItems: 'center',
        width: 140,
      },
      {
        prop: '_action',
        actionName: 'string1Commom',
        alignItems: 'start',
        width: 150,
      },
      {
        prop: '_action',
        actionName: 'string2Commom',
        alignItems: 'start',
        width: 150,
      },
      {
        prop: '_action',
        actionName: 'string3Commom',
        alignItems: 'start',
        width: 150,
      },
    ],
    tokenNameOrder: 'asc',
    itemNameOrder: 'asc',
    groupNameOrder: 'asc',
    groupFolderOrder: 'asc',
    groupVideosOrder: 'asc',
    groupTsOrder: 'asc',
    group: {
      name: '',
      percentTs: 0.1,
      fontFamily: 'fredoka-regular',
      fontColor: '#FFFFFFFF',
      fontSize: 12,
      boxColor: '#7999CEFF',
      boxOpacity: 1,
    },
    boxLines: {
      text1: 'Licenciado para',
      text2: 'Panda Video',
      text3: 'CPF 123.456.789-00',
    },
    privateKeysSearch: false,
    searchKeysText: '',
    isDrmItemDuplicated: false,
  }),
  computed: {
    ...mapState({
      mainFolders: (state) => state.user.mainFolders,
    }),
    menu() {
      return this.$store.state.user.securityNavItems
    },
    hasEditDrmPerm() {
      return (
        this.$store.state.user.userPermissions?.includes('put-watermark') ??
        false
      )
    },
    isLocalePT_BR() {
      return this.$i18next.resolvedLanguage === 'pt'
    },
    drmLink() {
      return this.isLocalePT_BR ? DRM_LINK_PT_BR : DRM_LINK_EN_US
    },
    filteredKeys() {
      return this.groupPrivateTokens.filter((item) =>
        item.key.toLowerCase().includes(this.searchKeysText.toLowerCase())
      )
    },
    anyItemSelected() {
      return this.selectedItems.length > 0
    },
    anyTokenSelected() {
      return this.selectedKeys.length > 0
    },
    checkboxIndeterminateStatus() {
      return (
        this.selectedItems.length > 0 &&
        this.selectedItems.length < this.loadedVideos.length
      )
    },
    checkboxIndeterminateStatusTokens() {
      return (
        this.selectedKeys.length > 0 &&
        this.selectedKeys.length < this.groupPrivateTokens.length
      )
    },
    anyTokensSelected() {
      return this.selectedKeys.length > 0
    },
    loadedItems() {
      if (this.loadedFolders.length > 0 || this.loadedVideos.length > 0) {
        return this.loadedFolders.concat(this.loadedVideos)
      }
      return []
    },
  },
  async created() {
    this.isFetching = true
    if (!window.db) {
      this.$root.$emit('initDexie')
    }
    if (!this.mainFolders.length) {
      this.readUserFolders()
    }
    await this.getDrmInfo()
    if (
      this.$route.name === 'DRMGroup' ||
      this.$route.name === 'DRMGroupKeys'
    ) {
      let findIfExists = this.drmWatermarkGroups.find(
        (group) => group.id === this.$route.params.id
      )
      if (findIfExists) {
        if (this.$route.name === 'DRMGroupKeys') {
          await this.handleSelectGroup(findIfExists)
          this.goToGroupKeys(false)
        } else {
          this.handleSelectGroup(findIfExists)
        }
      } else {
        this.$router.push({ name: 'DRM' })
      }
    }
    this.isFetching = false
  },
  mounted() {
    this.$root.$emit('changeNavItem', 2)
    this.$root.$on('addVideoFromDrm', async (video) => {
      this.loadedVideos.unshift(video)
    })
    this.$root.$on('removeVideoFromDrm', async (videos, groupId) => {
      for (let video of videos) {
        if (video.name) {
          this.loadedFolders = this.loadedFolders.filter(
            (item) => item.id != video.id
          )
        } else {
          this.loadedVideos = this.loadedVideos.filter(
            (item) => item.id != video.id
          )
        }
        let foundVideo = await window.db.videos.get(video.id)
        foundVideo.drm_group_ids = foundVideo.drm_group_ids.filter((group) => {
          return group.drm_group_id != groupId
        })
        await window.db.videos.update(foundVideo.id, foundVideo)
      }
      this.selectedItems = []
    })
    this.$root.$on('addNewDrmGroup', (group) => {
      this.drmWatermarkGroups.unshift(group)
    })
    this.$root.$on('updateDrmGroup', (group) => {
      if (group.id === this.selectedGroup.id) {
        this.selectedGroup = { ...this.selectedGroup, ...group }
      }
      this.drmWatermarkGroups = this.drmWatermarkGroups.map((item) => {
        return item.id == group.id ? { ...item, ...group } : item
      })
    })
    this.$root.$on('removeDrmGroup', (group) => {
      this.drmWatermarkGroups = this.drmWatermarkGroups.filter(
        (item) => item.id != group.id
      )
      if (this.selectedGroup.id === group.id) {
        this.selectedGroup = {}
      }
      this.UPDATE_SHOULD_FETCH_ALL_VIDEOS(true)
      this.$router.push({ name: 'DRM' })
    })
    this.$root.$on('addNewPrivateToken', (token) => {
      this.groupPrivateTokens.unshift(token)
    })
    this.$root.$on('updatePrivateToken', (token) => {
      this.groupPrivateTokens = this.groupPrivateTokens.map((item) =>
        item.id == token.id ? token : item
      )
    })
    this.$root.$on('removePrivateTokens', (tokens) => {
      for (let token of tokens) {
        this.groupPrivateTokens = this.groupPrivateTokens.filter(
          (item) => item.id != token.id
        )
      }
      this.selectedKeys = []
    })
    this.$root.$on('switchDrmValue', () => {
      this.isDrmActive = !this.isDrmActive
      if (!this.drmWatermarkGroups.length && this.isDrmActive) {
        this.getDrmGroups()
      }
    })
    this.setTableHeight()
    window.addEventListener('resize', this.setTableHeight)
  },
  watch: {
    tokenNameOrder: function () {
      this.orderTokenByName()
    },
    itemNameOrder: function () {
      this.orderItemsByName()
    },
    groupNameOrder: function () {
      this.orderGroupByName()
    },
    groupFolderOrder: function () {
      this.orderGroupByFolders()
    },
    groupVideosOrder: function () {
      this.orderGroupByVideos()
    },
    groupTsOrder: function () {
      this.orderGroupByTs()
    },
  },
  methods: {
    ...mapMutations('user', [
      'UPDATE_GLOBAL_SNACKBAR',
      'UPDATE_MAIN_FOLDERS',
      'UPDATE_SHOULD_FETCH_ALL_VIDEOS',
      'UPDATE_DELETED_FOLDERS',
      'UPDATE_ALL_FOLDERS',
    ]),
    handleKeysSearch() {
      this.privateKeysSearch = true
    },
    handleCloseSearchBar() {
      this.searchKeysText = ''
      this.privateKeysSearch = false
    },
    checkIfEscWasPressed(event) {
      if (event.keyCode === 27) {
        this.handleCloseSearchBar()
      }
    },
    async createDefaultGroup() {
      let groupObject = {
        name: 'Default',
        percent_ts: this.group.percentTs,
        video_ids: [],
        'font-family': this.group.fontFamily.toString(),
        'font-color': this.group.fontColor.toString(),
        'font-size': this.group.fontSize.toString(),
        'box-color': this.group.boxColor.toString(),
        'box-opacity': this.group.boxOpacity.toString(),
      }
      try {
        let ret = await drmApi.createDrmGroup(groupObject)
        let newGroup = ret.data
        newGroup.video_ids = []
        this.$root.$emit('addNewDrmGroup', newGroup)
      } catch (e) {
        console.log('e', e)
      }
    },
    orderGroupByTs() {
      if (this.groupTsOrder === 'asc') {
        this.drmWatermarkGroups.sort((a, b) => a.percent_ts - b.percent_ts)
      }
      if (this.groupTsOrder === 'desc') {
        this.drmWatermarkGroups.sort((a, b) => b.percent_ts - a.percent_ts)
      }
    },
    switchTsOrder() {
      if (!this.groupTsOrder || this.groupTsOrder === 'desc')
        return (this.groupTsOrder = 'asc')
      if (this.groupTsOrder === 'asc') return (this.groupTsOrder = 'desc')
    },
    orderGroupByVideos() {
      if (this.groupVideosOrder === 'asc') {
        this.drmWatermarkGroups.sort(
          (a, b) => a.video_ids.length - b.video_ids.length
        )
      }
      if (this.groupVideosOrder === 'desc') {
        this.drmWatermarkGroups.sort(
          (a, b) => b.video_ids.length - a.video_ids.length
        )
      }
    },
    switchVideoAmountOrder() {
      if (!this.groupVideosOrder || this.groupVideosOrder === 'desc')
        return (this.groupVideosOrder = 'asc')
      if (this.groupVideosOrder === 'asc')
        return (this.groupVideosOrder = 'desc')
    },
    orderGroupByFolders() {
      if (this.groupFolderOrder === 'asc') {
        this.drmWatermarkGroups.sort(
          (a, b) => a.folder_ids.length - b.folder_ids.length
        )
      }
      if (this.groupFolderOrder === 'desc') {
        this.drmWatermarkGroups.sort(
          (a, b) => b.folder_ids.length - a.folder_ids.length
        )
      }
    },
    switchFolderAmountOrder() {
      if (!this.groupFolderOrder || this.groupFolderOrder === 'desc')
        return (this.groupFolderOrder = 'asc')
      if (this.groupFolderOrder === 'asc')
        return (this.groupFolderOrder = 'desc')
    },
    orderGroupByName() {
      if (this.groupNameOrder === 'asc') {
        this.drmWatermarkGroups.sort((a, b) =>
          a.name.localeCompare(b.name, undefined, { numeric: true })
        )
      }
      if (this.groupNameOrder === 'desc') {
        this.drmWatermarkGroups.sort(
          (a, b) => -a.name.localeCompare(b.name, undefined, { numeric: true })
        )
      }
    },
    switchGroupNameOrder() {
      if (!this.groupNameOrder || this.groupNameOrder === 'desc')
        return (this.groupNameOrder = 'asc')
      if (this.groupNameOrder === 'asc') return (this.groupNameOrder = 'desc')
    },
    orderItemsByName() {
      if (this.itemNameOrder === 'asc') {
        this.loadedVideos.sort((a, b) => a.title.localeCompare(b.title))
        this.loadedFolders.sort((a, b) =>
          a.name.localeCompare(b.name, undefined, { numeric: true })
        )
      }
      if (this.itemNameOrder === 'desc') {
        this.loadedVideos.sort((a, b) => -a.title.localeCompare(b.title))
        this.loadedFolders.sort(
          (a, b) => -a.name.localeCompare(b.name, undefined, { numeric: true })
        )
      }
    },
    switchItemsNameOrder() {
      if (!this.itemNameOrder || this.itemNameOrder === 'desc')
        return (this.itemNameOrder = 'asc')
      if (this.itemNameOrder === 'asc') return (this.itemNameOrder = 'desc')
    },
    orderTokenByName() {
      if (this.tokenNameOrder === 'asc') {
        this.groupPrivateTokens.sort((a, b) =>
          a.key.localeCompare(b.key, undefined, { numeric: true })
        )
      }
      if (this.tokenNameOrder === 'desc') {
        this.groupPrivateTokens.sort(
          (a, b) => -a.key.localeCompare(b.key, undefined, { numeric: true })
        )
      }
    },
    switchTokenNameOrder() {
      if (!this.tokenNameOrder || this.tokenNameOrder === 'desc')
        return (this.tokenNameOrder = 'asc')
      if (this.tokenNameOrder === 'asc') return (this.tokenNameOrder = 'desc')
    },
    async getPrivateTokens() {
      this.fetchingPrivateKeys = true
      let dataObject = {
        drm_group_id: this.selectedGroup.id,
      }
      try {
        let ret = await drmApi.getDrmPrivateTokens(dataObject)
        ret.data.tokens
          ? (this.groupPrivateTokens = ret.data.tokens)
          : (this.groupPrivateTokens = [])
      } catch (e) {
        this.fetchingPrivateKeys = false
        console.log('ERR/get private tokens', e)
      }
      this.fetchingPrivateKeys = false
    },
    async readUserFolders() {
      try {
        let ret = await foldersApi.getUserFolders()
        let notDeletedFolders = ret.data.folders.filter(
          (folder) => folder.status != false
        )
        let deletedFolders = ret.data.folders.filter(
          (folder) => folder.status === false
        )
        this.UPDATE_MAIN_FOLDERS(notDeletedFolders)
        this.UPDATE_DELETED_FOLDERS(deletedFolders)
        this.UPDATE_ALL_FOLDERS(ret.data.folders)
      } catch (e) {
        console.error(e)
      }
    },
    show(item, e) {
      this.menuItem = item
      e.preventDefault()
      this.showMenu = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showMenu = true
      })
    },
    showDrmMenu(item, e) {
      this.menuItemDrm = item
      e.preventDefault()
      this.showMenuDrm = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showMenuDrm = true
      })
    },
    showTokensMenu(item, e) {
      this.menuItemTokem = item
      e.preventDefault()
      this.showMenuTokem = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showMenuTokem = true
      })
    },
    handleRemoveItemFromDrm(item) {
      let arr = []
      arr.push(item)
      this.$root.$emit('openDrmRemoveVideo', {
        group: this.selectedGroup,
        videos: arr,
      })
    },
    handleGoToAdvanced() {
      this.$root.$emit('openDrmModalGroupSettings', 3)
    },
    handleDrmSettings() {
      this.$root.$emit('openDrmModalGroupSettings', 0)
    },
    handleRemoveItems() {
      this.$root.$emit('openDrmRemoveVideo', {
        group: this.selectedGroup,
        videos: this.selectedItems,
      })
    },
    checkIfSelectedToken(item) {
      let foundItem = this.selectedKeys.find((searchedItem) => {
        return searchedItem.id === item.id
      })
      if (foundItem) return true
      return false
    },
    checkboxSelectionToken(item) {
      let alreadySelected = this.checkIfSelectedToken(item)
      if (alreadySelected) {
        let newArr = [
          ...this.selectedKeys.filter((lookToken) => {
            return lookToken.id !== item.id
          }),
        ]
        this.selectedKeys = [...newArr]
      } else {
        this.selectedKeys.push(item)
      }
    },
    checkIfSelected(item) {
      let foundItem = this.selectedItems.find((searchedItem) => {
        return searchedItem.id === item.id
      })
      if (foundItem) return true
      return false
    },
    checkboxSelection(item) {
      let alreadySelected = this.checkIfSelected(item)
      if (alreadySelected) {
        let newArr = [
          ...this.selectedItems.filter((lookFolder) => {
            return lookFolder.id !== item.id
          }),
        ]
        this.selectedItems = [...newArr]
      } else {
        this.selectedItems.push(item)
      }
    },
    async getGroupVideos(group) {
      this.loadedVideos = []
      this.loadedFolders = []
      let toBeFetchVideos = group.video_ids
      let toBeFetchFolders = group.folder_ids
      let newLoadedArray = []
      let newFolderArray = []
      for (let videoId of toBeFetchVideos) {
        let foundVideo = await window.db.videos.get(videoId)
        if (foundVideo?.title) {
          newLoadedArray.push(foundVideo)
        }
      }
      for (let folderId of toBeFetchFolders) {
        let foundFolder = this.mainFolders.find((el) => el.id === folderId)
        if (foundFolder?.name) {
          newFolderArray.push(foundFolder)
        }
      }
      this.loadedFolders = newFolderArray
      this.loadedVideos = newLoadedArray
    },
    handleClickRow() {},
    handleEditGroup(group) {
      this.$root.$emit('openDrmCreateGroup', { item: group, edit: true })
    },
    handleSelectGroup(group) {
      this.getGroupVideos(group)
      this.selectedGroup = group
      if (this.$route.name != 'DRMGroup' && this.$route.params.id != group.id) {
        this.$router.push({ name: 'DRMGroup', params: { id: group.id } })
      }
    },
    handleRowSecretToken(token) {
      this.$root.$emit('openDrmSecretKey', {
        group: this.selectedGroup,
        item: token,
        edit: true,
      })
    },
    goToGroupKeys(shouldNavigate) {
      if (shouldNavigate) {
        this.$router.push({
          name: 'DRMGroupKeys',
          params: { id: this.selectedGroup.id },
        })
      }
      this.groupTab = 1
      this.getPrivateTokens()
    },
    clearGroup() {
      this.isDrmItemDuplicated = false
      if (this.groupTab === 1) {
        this.$router.push({
          name: 'DRMGroup',
          params: { id: this.selectedGroup.id },
        })
        this.groupTab = 0
        return
      }
      this.$router.push({ name: 'DRM' })
      this.selectedGroup = {}
      this.groupPrivateTokens = []
    },
    async getDrmInfo() {
      this.loadings.drmInfo = true
      try {
        let ret = await drmApi.getDrm()
        this.isDrmActive = ret.data.status
        if (ret.data.status) {
          this.getDrmGroups()
        }
      } catch (e) {
        this.loadings.drmInfo = false
        console.log('e', e)
      }
      this.loadings.drmInfo = false
    },
    async getDrmGroups() {
      this.loadings.watermarkGroups = true
      this.errors.groupsError = false
      try {
        let ret = await drmApi.getDrmGroups()
        this.drmWatermarkGroups = ret.data
        if (!this.drmWatermarkGroups.length) {
          this.createDefaultGroup()
        }
      } catch (error) {
        this.loadings.watermarkGroups = false
        this.errors.groupsError = true
        if (!error.code) {
          const anyError = JSON.parse(JSON.stringify(error))
          if (anyError.message.includes('Network Error')) {
            this.groupsUnknownErrorCode = '504'
            return
          }
        }
        this.errors.groupsUnknownErrorCode = error.code
      }
      this.loadings.watermarkGroups = false
    },
    async handleActiveDRM() {
      this.loadings.activateDrm = true
      try {
        await drmApi.activateDrm()
      } catch (e) {
        this.loadings.activateDrm = false
        console.log('e', e)
      }
      this.loadings.activateDrm = false
    },
    async handleDeactivateDRM() {
      this.loadings.deactivateDrm = true
      try {
        await drmApi.deactivateDrm()
      } catch (e) {
        this.loadings.deactivateDrm = false
        console.log('e', e)
      }
      this.loadings.deactivateDrm = false
    },
    async handleDeleteGroup(group) {
      this.$root.$emit('drmRemoveGroupModal', group)
    },
    handleDrmSwitch() {
      this.$root.$emit('openDrmWarning', this.isDrmActive)
    },
    handleNewDrmCategory() {
      this.$root.$emit('openDrmCreateGroup')
    },
    copyTextToClipboard() {
      if (!this.secretKey) {
        return
      }
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: i18n.t('message.copiedToClipboard'),
      })
      navigator.clipboard.writeText(`${this.secretKey}`)
    },
    selectAllItems() {
      if (this.selectedItems.length === this.loadedItems.length) {
        this.selectedItems = []
        return
      }
      this.selectedItems = [...this.loadedItems]
    },
    selectAllTokens() {
      if (this.selectedKeys.length === this.groupPrivateTokens.length) {
        this.selectedKeys = []
        return
      }
      this.selectedKeys = [...this.groupPrivateTokens]
    },
    async filterSearch(typedValue) {
      this.isDrmItemDuplicated = false
      this.loadingSearchBar = true
      if (typedValue && typedValue.length > 0) {
        let folders = [...this.mainFolders]
        let list = await window.db.videos.toArray()

        for (const folder of folders) {
          list.push(folder)
        }

        let fuseOptions = {
          keys: ['title', 'name'],
          includeScore: true,
          threshold: 0.4,
        }
        const fuse = new Fuse(list, fuseOptions)
        let searchResult = fuse.search(typedValue)

        let itemsResults = searchResult.map((character) => character.item)
        let idFilter = [
          ...this.loadedItems.map((item) => {
            return item.id
          }),
        ]
        let filterResults = itemsResults.filter(
          (item) => !idFilter.includes(item.id)
        )
        this.filteredVideoList = filterResults
      } else {
        this.filteredVideoList = []
      }
      this.loadingSearchBar = false
    },
    handleSelectRowItem(item) {
      this.addToBeAddedItems(item)
      this.checkIfClicked = true
      this.$refs.autoCompleteInputDRM.clearableCallback()
      this.$refs.autoCompleteInputDRM.isFocused = false
      setTimeout(() => {
        this.checkIfClicked = false
      }, 300)
    },
    async hasDrmGroup(item) {
      const isVideo = !!item.video_player
      if (isVideo) {
        const {
          data: { videos },
        } = await videosApi.getAllVideos()
        const allVideos = Object.values(videos)
        let foundVideo = {}
        for (let videos of allVideos) {
          foundVideo = videos.find(function (video) {
            return video.id === item.id
          })
          if (foundVideo) {
            break
          }
        }
        return !!foundVideo?.hasOwnProperty('drm_group_ids')
      } else {
        await this.readUserFolders()
        const mainFolders = this.mainFolders
        return mainFolders.some(
          (folder) =>
            folder.drm_group_ids &&
            Object.values(folder).some((id) => id === item.id)
        )
      }
    },
    async addToBeAddedItems(item) {
      if (this.checkIfClicked) return
      const hasDrmGroup = await this.hasDrmGroup(item)
      this.isDrmItemDuplicated = hasDrmGroup
      if (!hasDrmGroup) {
        this.toBeAddedItems.push(item)
        this.saveToBeAddedItems()
      }
    },
    async saveToBeAddedItems() {
      this.loadingVideosAdd = true
      let items = this.toBeAddedItems
      let folderIds = []
      let videoIds = []
      for (let item of items) {
        if (item.name) {
          folderIds.push(item.id)
        }
        if (item.title) {
          videoIds.push(item.id)
        }
      }
      try {
        let ret = await drmApi.drmUpdateVideos(this.selectedGroup.id, {
          videos: {
            action: 'increment',
            video_ids: videoIds,
          },
          folders: {
            action: 'increment',
            folder_ids: folderIds,
          },
        })
        for (let videoId of videoIds) {
          let foundVideo = await window.db.videos.get(videoId)
          let newObj = {
            active: this.selectedGroup.active,
            drm_group_id: this.selectedGroup.id,
          }
          if (foundVideo.drm_group_ids) {
            foundVideo.drm_group_ids.push(newObj)
          } else {
            foundVideo.drm_group_ids = [newObj]
          }
          await window.db.videos.update(foundVideo.id, foundVideo)
          this.loadedVideos.unshift(foundVideo)
        }
        for (let folderId of folderIds) {
          let foundFolder = this.mainFolders.find((el) => el.id === folderId)
          this.loadedFolders.unshift(foundFolder)
        }
        let findGroupIndex = this.drmWatermarkGroups.findIndex(
          (obj) => obj.id == this.selectedGroup.id
        )
        if (videoIds.length > 0) {
          this.drmWatermarkGroups[findGroupIndex].video_ids = ret.data.video_ids
        }
        if (folderIds.length > 0) {
          this.drmWatermarkGroups[findGroupIndex].folder_ids =
            ret.data.folder_ids
        }
        this.toBeAddedItems = []
      } catch (e) {
        this.loadingVideosAdd = false
        console.log('e', e)
      }
      this.loadingVideosAdd = false
    },
    handleSearchBlur() {
      this.filteredVideoList = []
    },
    removeFromAddedItems(removingItem) {
      this.toBeAddedItems = this.toBeAddedItems.filter(
        (item) => item.id != removingItem.id
      )
    },
    handleGrowSearchBar() {
      this.openSearchBar = true
    },
    handleUngrowBar() {
      this.openSearchBar = false
    },
    getFoldersInsideGroup(group) {
      let size = parseInt(group.folder_ids.length)
      return size ? `${size}` : '0'
    },
    getQuantityInsideGroup(group) {
      let size = parseInt(group.video_ids.length)

      let videoCountInsideFolders = this.getVideosCountInsideFolders(
        group.folder_ids
      )
      let totalVideoCount = size + videoCountInsideFolders

      return String(totalVideoCount || 0)
    },
    getVideosCountInsideFolders(folderIds) {
      if (!folderIds.length) return 0

      return folderIds.reduce(
        (total, folderId) => total + this.calculateVideoCount(folderId),
        0
      )
    },
    calculateVideoCount(folderId) {
      const allFolders = this.mainFolders

      const parentFolders = allFolders.filter(
        (folder) => folder.id === folderId
      )

      const videosCountInChildFolders = this.countVideosInChildFolders(
        allFolders,
        folderId
      )

      const videoCountInParentFolders = parentFolders
        .map((folder) => parseInt(folder.videos_count, 10) || 0)
        .reduce((acc, count) => acc + count, 0)

      return videosCountInChildFolders + videoCountInParentFolders
    },
    countVideosInChildFolders(allFolders, folderId) {
      const childFoldersIds = []

      // Função recursiva para procurar pastas com parent_folder_id igual a folderId
      function findChildFolders(currentFolderId) {
        const foldersWithParent = allFolders.filter(
          (folder) => folder.parent_folder_id === currentFolderId
        )

        for (let folder of foldersWithParent) {
          childFoldersIds.push(folder.id)
          findChildFolders(folder.id)
        }
      }

      findChildFolders(folderId)

      // Soma os video_count das pastas encontradas
      const totalChildFoldersVideoCount = childFoldersIds.reduce(
        (acc, currentFolderId) => {
          const folder = allFolders.find((f) => f.id === currentFolderId)
          const videoCount = folder ? parseInt(folder.videos_count, 10) ?? 0 : 0
          return acc + videoCount
        },
        0
      )

      return totalChildFoldersVideoCount
    },
    handleCreateSecretKey() {
      this.$root.$emit('openDrmSecretKey', {
        group: this.selectedGroup,
        item: {},
        edit: false,
      })
    },
    handleRemoveMultipleKeys() {
      this.$root.$emit('drmRemoveMultipleKeysModal', this.selectedKeys)
    },
    handleStatusPage() {
      return window.open(PANDA_STATUS_PAGE_BR, '_blank')
    },
    setTableHeight() {
      const pageViewContentElement = document.querySelector(
        '.page-view__content'
      )
      const pageViewHeight = Math.round(
        pageViewContentElement.getBoundingClientRect().height
      )
      this.tableHeight = pageViewHeight * 0.65
    },
  },
}
</script>

<style lang="scss">
.pageTitle {
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  color: var(--v-brand-darken2);
}

.svgSize {
  width: 450px;
}

.displayBlock {
  display: block;
}

.displayNone {
  display: none;
}

.t-header {
  display: none;
}

.t-header span {
  font-weight: bold;
}

.toolbarMargin .v-toolbar__content {
  margin-left: 0;
  padding-left: 0;
}

div.item-line:hover .hoveredClass {
  display: block;
}

div.item-line .hoveredClass {
  display: none;
}

.noFilesAddedText {
  font-weight: 400;
  font-size: 20px;
  line-height: 135%;
  text-align: center;
  color: #d6d6d6;
}

.svgArrowUp {
  position: relative;
  bottom: 300px;
  right: 40px;
}

.pointerTable {
  cursor: pointer;
}
</style>
